import { PageContent } from "../Elements/Elements.tsx";

const NoMatch = () => {
  return (
    <PageContent>
      La page que vous demandez n&apos;a pas été trouvée.
    </PageContent>
  );
};

export default NoMatch;
